import { tansParams, blobValidate } from "@/util/ruoyi";
import axios from 'axios';
import { Message } from 'element-ui';
import { saveAs } from 'file-saver'
import { showLoading, hideLoading } from './loading';
const API_BASE = process.env.API_BASE || 'https://www.hsyl-tech.com/prod-api/'
const IMG_BASE = process.env.IMG_BASE || `${API_BASE.replace(/\/$/, '')}/profile`
export const imgUrl = IMG_BASE

function joinUrl(base, path) {
  const baseValue = (base || '').replace(/\/+$/, '')
  const pathValue = (path || '').replace(/^\/+/, '')
  return `${baseValue}/${pathValue}`
}
// 请求超时时间
axios.defaults.timeout = 10000;

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = window.localStorage.getItem("token");
    // // const token = '88222f91-f17d-402c-880c-c5e9d44167c9'
    // token && (config.headers.cwm_auth_token = token);
    return config;
  },
  error => {
    return Promise.reject(error);
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200 ) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error && error.response && error.response.status) {
      const message = error.response.data && (error.response.data.msg || error.response.data.message)
      switch (error.response.status) {
        // 401: 未登录
        case 401:
          Message.error(message || '未登录');
          break;
        default:
          Message.error(message || '网络错误');
      }
      return Promise.reject(error);
    }
    Message.error("网络错误");
    return Promise.reject(error)
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  showLoading()
  return new Promise((resolve, reject) => {
    axios.get(joinUrl(API_BASE, url), {
      params: params
    }).then(res => {
          if(res.data.code==200){
            resolve(res.data);
          }else{
            Message.error(res.data.msg)
            reject(res.data)
          }
          hideLoading()
        }).catch(err => {
        hideLoading()
          const errorData = err && err.response ? err.response.data : null
          if(errorData){
            if(errorData.code!=200){
              Message.error(errorData.msg || "网络错误")
            }
            reject(errorData)
          }else{
            Message.error("网络错误");
            reject(err)
          }
        })
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function post(url, params,headerType='application/json;charset=UTF-8') {
  showLoading()
  return new Promise((resolve, reject) => {
    axios.post(joinUrl(API_BASE, url), params,{
      headers:{
        'Content-Type':headerType
      }
    }).then(res => {
      if(res.data.code==200){
        resolve(res.data);
      }else{
        Message.error(res.data.msg)
        reject(res.data)
      }
      hideLoading()
    }).catch(err => {
      hideLoading()
      const errorData = err && err.response ? err.response.data : null
      if(errorData){
        if(errorData.code!=200){
          Message.error(errorData.msg || "网络错误")
        }
        reject(errorData)
      }else{
        Message.error("网络错误");
        reject(err)
      }
    })
  });
}

// 通用下载方法
export function download (url, params) {
  showLoading()
  return axios.post(joinUrl(API_BASE, url), params, {
      transformRequest: [(params) => { return tansParams(params) }],
      headers:{'Content-Type': 'application/x-www-form-urlencoded'},
      responseType: 'blob',
    }).then(async (data) => {
      hideLoading()
      const isBlob = blobValidate(data.data);
      if (isBlob) {
        const blob = new Blob([data.data])
        saveAs(blob, `培训信息_${new Date().getTime()}.zip`)
      } else {
        Message.error(data.msg);
      }
  }).catch(err => {
      hideLoading()
      const errorData = err && err.response ? err.response.data : null
      if(errorData){
        if(errorData.code!=200){
          Message.error(errorData.msg || "网络错误")
        }
      }else{
        Message.error("网络错误");
      }
      return Promise.reject(errorData || err)
    })
}




// WEBPACK FOOTER //
// ./src/request/http.js